import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import PinkButton from "../../components/customButtons/PinkButton";


export default function ConnectionLostPage() {
  return (
    <>
      <Grid
        container
        spacing={2}
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="100vh"
        width="100%"
      >
        <Box width={412}>
          <img src="/newdashboard/ErrorPageIcons/27490851_illustration_13 (1) 1.png" />
        </Box>

        <Typography
       
          color="#000000"
          fontFamily="Inter"
          fontSize="24px"
          letterSpacing="0px"
          style={{ fontWeight: 700 }}
        >
          {" "}
       Connection Lost...
        </Typography>

        <Typography
          color="#000000"
          fontFamily="Inter"
          fontSize="20px"
          mt={2}
          letterSpacing="0px"
          textAlign="center"
          style={{ fontWeight: 400 }}
        >
          {" "}
        No internet connection found, check you connection
        </Typography>

        <Box mt={3}>
          <PinkButton
            buttonTitle="Retry"
            startIcon={<img src="/newdashboard/ErrorPageIcons/fa_repeat.png" />}
          />
        </Box>
      </Grid>
    </>
  )
}
